import React from 'react';
import { Link } from 'react-router-dom';
import AppHeader from './AppHeader';
import { useBranding } from '../Context/BrandingContext';
import { useLoginModal } from '../Context/LoginModalContext';

/**
 * Full-page notice shown when a guest or pending user tries to open a gated
 * view (e.g. product detail). Approved (STANDARD+) users never see this — they
 * are allowed straight through to the detail page.
 */
export default function RestrictedAccess({ isGuest, redirectPath = '/catalog' }) {
  const { branding } = useBranding();
  const { openLogin } = useLoginModal();

  return (
    <div style={styles.page}>
      <AppHeader />
      <main style={styles.main}>
        <div style={styles.card}>
          <h1 style={styles.title}>
            {isGuest ? 'Sign in to view details' : 'Access pending approval'}
          </h1>
          <p style={styles.text}>
            {isGuest
              ? 'Browsing search results is open to everyone, but viewing product details requires an account. Sign in to continue.'
              : 'Your account is awaiting approval. You can search and view results now — product details will be available once an administrator approves your access.'}
          </p>
          <div style={styles.actions}>
            {isGuest && (
              <button
                type="button"
                style={{ ...styles.primaryBtn, backgroundColor: branding.primaryColor }}
                onClick={() => openLogin({ redirectPath })}
              >
                Sign in
              </button>
            )}
            <Link to="/catalog" style={styles.secondaryBtn}>← Back to search</Link>
          </div>
        </div>
      </main>
    </div>
  );
}

const styles = {
  page: { minHeight: '100vh', backgroundColor: 'var(--background)', color: 'var(--foreground)' },
  main: { padding: '48px 24px', display: 'flex', justifyContent: 'center' },
  card: {
    maxWidth: 520, width: '100%', textAlign: 'center',
    backgroundColor: 'var(--card)', border: '1px solid var(--border)',
    borderRadius: 14, padding: '40px 32px', boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
  },
  title: { margin: '0 0 12px', fontSize: 22, fontWeight: 800 },
  text: { margin: '0 0 24px', fontSize: 15, lineHeight: 1.55, color: 'var(--muted-foreground)' },
  actions: { display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' },
  primaryBtn: {
    border: 'none', borderRadius: 8, padding: '10px 22px',
    color: 'white', fontWeight: 700, fontSize: 14, cursor: 'pointer',
  },
  secondaryBtn: {
    display: 'inline-block', border: '1px solid var(--border)', borderRadius: 8,
    padding: '10px 18px', color: 'var(--foreground)', fontWeight: 600,
    fontSize: 14, textDecoration: 'none', backgroundColor: 'var(--background)',
  },
};
